export default "__VITE_ASSET__CnOxjcrt__"